import "./views/ticket-card-animation";